import { createReducer } from '@reduxjs/toolkit';

import { initialState, setCurrentJobId } from '../Actions/menuJobIdAction';

import type { MenuJobIdState } from '../Actions/menuJobIdAction';

const menuJobIdReducer = createReducer<MenuJobIdState>(initialState, (builder) => {
  builder
    .addCase(setCurrentJobId, (state, action) => {
      state.currentJobId = action.payload;
    });
});

export default menuJobIdReducer; 